var map = {
  "./messages_id.json": [
    "78728",
    "9585"
  ],
  "./messages_th.json": [
    "99325",
    "2302"
  ],
  "./messages_uk.json": [
    "92493",
    "7742"
  ],
  "./messages_so.json": [
    "67895",
    "1100"
  ],
  "./messages_it.json": [
    "49240",
    "6577"
  ],
  "./messages_en.json": [
    "74350",
    "3907"
  ],
  "./messages_es.json": [
    "21029",
    "9558"
  ],
  "./messages_sv.json": [
    "59804",
    "2765"
  ],
  "./messages_tr.json": [
    "88235",
    "5448"
  ],
  "./messages_hi.json": [
    "27758",
    "5219"
  ],
  "./messages_ru.json": [
    "97640",
    "7729"
  ],
  "./messages_de.json": [
    "13270",
    "5739"
  ],
  "./messages_ko.json": [
    "36255",
    "4260"
  ],
  "./messages_fr.json": [
    "68909",
    "9566"
  ],
  "./messages_fi.json": [
    "94808",
    "1105"
  ],
  "./messages_ja.json": [
    "11020",
    "1293"
  ],
  "./messages_cs.json": [
    "723",
    "9312"
  ],
  "./messages_da.json": [
    "15482",
    "4407"
  ],
  "./messages_no.json": [
    "85566",
    "227"
  ],
  "./messages_pt.json": [
    "91405",
    "7966"
  ],
  "./messages_vi.json": [
    "92520",
    "961"
  ],
  "./messages_zh.json": [
    "27303",
    "1980"
  ],
  "./messages_nl.json": [
    "19359",
    "1556"
  ],
  "./messages_pl.json": [
    "37973",
    "1622"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1]).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 6768;
module.exports = __rspack_async_context;
